import { Chakra } from "@airhelp/react-ui-components";

import { useUserContext } from "contexts/HelpAFriend/UserContext";

import NewUserView from "./NewUserView";
import ReturningUserView from "./ReturningUserView";

const { ModalCloseButton, Box, useBreakpointValue } = Chakra;

const Modal = () => {
  const { userEmail, shareLink } = useUserContext();

  return (
    <Box backgroundColor="white" p={10} pt={8} rounded={{ base: "none", lg: "3xl" }}>
      <ModalCloseButton
        position="absolute"
        top={2}
        right={2}
        color="primary.900"
        _hover={{ color: "primary.500", bg: "white" }}
        _active={{ color: "primary.700", bg: "white" }}
        rounded="full"
        size={useBreakpointValue({ base: "lg", lg: "md" })}
      />
      {shareLink && userEmail ? <ReturningUserView /> : <NewUserView />}
    </Box>
  );
};

export default Modal;
